import "./CustomersRequests.css";

/**
 * RequestDetailsModal
 * Read-only view of a service request.
 * Admins can only view — businesses/freelancers respond on their own side.
 */
const RequestDetailsModal = ({ request: r, onClose, formatDate, formatBudget }) => {
  if (!r) return null;

  const skills      = Array.isArray(r.skillsRequired) ? r.skillsRequired : [];
  const attachments = Array.isArray(r.attachments)    ? r.attachments    : [];

  const statusLabels = {
    open:        "Open",
    in_progress: "In Progress",
    resolved:    "Resolved",
    closed:      "Closed",
  };

  return (
    <div className="sr-modal-backdrop" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="sr-modal">

        {/* HEADER */}
        <div className="sr-modal-header">
          <div>
            <h2 className="sr-modal-title">{r.title || "Service Request"}</h2>
            <p className="sr-modal-sub">
              Submitted by <strong>{r.customerName || r.submittedBy || r.customerEmail || "Unknown"}</strong>
              {r.createdAt ? ` · ${formatDate(r.createdAt)}` : ""}
            </p>
          </div>
          <button className="sr-modal-close" onClick={onClose} aria-label="Close">
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>

        {/* BODY */}
        <div className="sr-modal-body">

          {/* INFO GRID */}
          <div className="sr-detail-grid">
            <div className="sr-field">
              <label>Submitted By</label>
              <span>{r.customerName || r.submittedBy || "—"}</span>
            </div>
            <div className="sr-field">
              <label>Email</label>
              <span>{r.customerEmail || "—"}</span>
            </div>
            <div className="sr-field">
              <label>Category</label>
              <span>{r.category || "—"}</span>
            </div>
            <div className="sr-field">
              <label>Status</label>
              <span className={`status status-${r.status}`}>
                {statusLabels[r.status] || r.status || "Unknown"}
              </span>
            </div>
            <div className="sr-field">
              <label>Budget</label>
              <span>{r.budget ? formatBudget(r.budget) : "—"}</span>
            </div>
            <div className="sr-field">
              <label>Delivery Date</label>
              <span>{r.deliveryDate ? formatDate(r.deliveryDate) : "—"}</span>
            </div>
            <div className="sr-field sr-field-full">
              <label>Location</label>
              <span>{r.location || "—"}</span>
            </div>
            {skills.length > 0 && (
              <div className="sr-field sr-field-full">
                <label>Skills Required</label>
                <div className="sr-skills">
                  {skills.map((s, i) => (
                    <span key={i} className="sr-skill-pill">{s}</span>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* DESCRIPTION */}
          <div className="sr-section">
            <label>Description</label>
            <div className="sr-description">
              {r.description || "No description provided."}
            </div>
          </div>

          {/* ATTACHMENTS */}
          <div className="sr-section">
            <label>Attachments ({attachments.length})</label>
            {attachments.length === 0 ? (
              <p className="sr-empty-text">No attachments</p>
            ) : (
              <div className="sr-attachments">
                {attachments.map((url, i) => (
                  <a
                    key={i}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="sr-attachment-link"
                  >
                    <span className="material-symbols-outlined">attach_file</span>
                    Attachment {i + 1}
                  </a>
                ))}
              </div>
            )}
          </div>

        </div>

        {/* FOOTER */}
        <div className="sr-modal-footer">
          <p className="sr-readonly-note">
            <span className="material-symbols-outlined">info</span>
            This request is responded to by businesses or freelancers on the platform.
          </p>
          <button className="sr-btn-close" onClick={onClose}>Close</button>
        </div>

      </div>
    </div>
  );
};

export default RequestDetailsModal;